import { _js } from '@ifixit/localize';
import { tabletDetected, mobileDetected } from 'Shared/utils/mobile-detect';
import tippy from 'tippy.js';
import 'Shared/tippy-legacy-theme.css';
import 'tippy.js/themes/light.css';

/**
 * Class MediaItemMenu
 */
export default new Class({
   Implements: [Options, Events],

   options: {
      tooltip: {
         zIndex: 1_000_100,
      },
   },

   initialize: function () {
      this.sides = {};
      this.items = {};
      this.isOpen = false;

      // Fires events for each of the menu items
      this.menuItems = new Events();

      this.menu = new Element('div.mediaItemMenu', {
         events: {
            mousedown: function (ev) {
               ev.stop();
            },
         },
      }).adopt(
         (this.sides.left = new Element('ul.left')),
         (this.sides.right = new Element('ul.right')),
         (this.sides.bottom = new Element('div.bottom.clearer'))
      );

      this.addMenuItems();
   },

   addMenuItems: function () {
      let items = {
         // Full-size menu item.
         fullsize: {
            side: 'left',
            text: _js('Full Size'),
            icon: 'iconFullsize',
         },

         /**
          * Delete menu item.
          * The even name is 'deleted' so it doesn't clash with the keyword
          */
         deleted: {
            side: 'right',
            text: _js('Delete'),
            icon: 'iconDelete',
         },

         // Copy item to media manager
         copy: {
            side: 'right',
            text: _js('Copy'),
            icon: 'iconCopy',
            hoverText: _js('Copy to Media Manager'),
         },
      };

      // Only Allow markers and cropping on non-mobile browsers
      if (!mobileDetected() && !tabletDetected()) {
         // Markers menu item.
         items.markers = {
            side: 'left',
            text: _js('Markers...'),
            icon: 'iconMarkers',
         };

         // Crop menu item.
         items.crop = {
            side: 'left',
            text: _js('Crop...'),
            icon: 'iconCrop',
         };
      }

      Object.each(
         items,
         function (options, menuItemName) {
            this.addItem(menuItemName, options);
         },
         this
      );
   },

   addItem: function (name, options) {
      let self = this;
      let link;
      let item = new Element('li', {
         events: {
            mouseenter: this.hoverItem.bind(this, name),
            mouseleave: this.blurItem.bind(this, name),
            click: function (ev) {
               ev.stop();
               if (this.hasClass('inactive')) {
                  return;
               }
               // Fire the event
               self.menuItems.fireEvent(name, [self.mediaItem]);
               if (options.onSelect) {
                  options.onSelect();
               }
               self._close();
            },
         },
      }).adopt(
         new Element('div.icon.' + options.icon),
         (link = new Element('a', {
            text: options.text,
            events: {
               click: function (ev) {
                  ev.preventDefault();
               },
            },
         }))
      );

      if (options.hoverText) {
         item.tooltip = tippy(item, {
            content: options.hoverText,
            delay: 0,
            placement: 'bottom',
            zIndex: this.options.tooltip.zIndex + 1,
         });

         // item.addEvent('click', item.tooltip.hide.bind(item.tooltip));
      }

      item.inject(this.sides[options.side]);

      // Used to alter the 'title' attr when an item is disabled
      item.store('link', link);
      this.items[name] = item;
      return this;
   },

   disableItem: function (name) {
      this.items[name].addClass('inactive');
      return this;
   },

   enableItem: function (name) {
      this.items[name].removeClass('inactive');
      return this;
   },

   toggleForMediaItem: function (mediaItem, menuAnchor) {
      if (this.tooltip && this.tooltip.state.isVisible && mediaItem == this.mediaItem) {
         this._close();
      } else {
         if (this.tooltip && this.tooltip.state.isVisible) {
            this.tooltip.hide();
         }
         this.mediaItem = mediaItem;
         let validOptions = mediaItem.collectMenuOptions();
         Object.each(this.items, (item, name) => {
            let validOption = validOptions[name];
            // if the menu item is set to a string, it will be disabled
            // and the tooltip (title attr) will be set to the string
            let hasDisabledMessage = typeOf(validOption) == 'string';
            let link = item.retrieve('link');

            item.toggle(validOption);
            item.toggleClass('inactive', hasDisabledMessage);
            link.set('title', hasDisabledMessage ? validOption : '');
         });
         this._openAtAnchor(menuAnchor);
      }
   },

   /* Private Methods */

   _close: function () {
      this.tooltip.destroy();
      return this;
   },

   _openAtAnchor: function (anchor) {
      if (anchor) {
         if (this.tooltip) {
            this.tooltip.destroy();
         }

         this.tooltip = tippy(anchor, {
            zIndex: this.options.tooltip.zIndex,
            appendTo: document.body,
            interactive: true,
            allowHTML: true,
            theme: 'globalTippyStyles light',
            trigger: 'manual',
            content: this.menu,
         });
         this.tooltip.show();
      } else {
         this.tooltip.setContent(this.menu).show();
      }

      return this;
   },

   _hideItem: function (name) {
      this.items[name].hide();
      return this;
   },

   _showItem: function (name) {
      this.items[name].show();
      return this;
   },

   hoverItem: function (name) {
      let li = this.items[name];
      if (!li.hasClass('inactive')) {
         li.addClass('active');
      }
   },

   blurItem: function (name) {
      let li = this.items[name];
      li.removeClass('active');
   },

   selectItem: function (name, action) {
      let li = this.items[name];
      if (!li.hasClass('inactive')) {
         let closeMenu = action();
         if (closeMenu !== false) {
            this.close();
         }
      }
   },
});
